import { Delivery } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useDeliveries = (
  projectId: string,
  notificationId: string,
  options: Omit<UseSuspensePaginatedQueryOptions<Delivery>, "queryKey" | "url">,
) => {
  return useSuspensePaginatedQuery<Delivery>({
    queryKey: ["projects", projectId, "notifications", notificationId, "deliveries"],
    url: `/projects/${projectId}/notifications/${notificationId}/deliveries`,
    ...options
  });
};
